import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.75 11.5V2.75c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2M13.75 15.25c0 1.1-.9 2-2 2h-9c-1.1 0-2-.9-2-2v-.95M4.75 9h11.5M13.75 12.5l3.5-3.5-3.5-3.5"
    }, null, -1)
  ]))]))
}
export default { render: render }